import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Seo from '../components/Seo';
import posts from '../blog/posts';

import '../style/blog.css';

function formatDate(iso, lang) {
    return new Date(iso).toLocaleDateString(lang === 'en' ? 'en-US' : 'fr-FR', {
        year: 'numeric', month: 'long', day: 'numeric'
    });
}

function BlogPage() {
    const { t, i18n } = useTranslation();
    const lang = i18n.language?.startsWith('en') ? 'en' : 'fr';

    return (
        <div className="blog-page">
            <Seo path='/blog' titleKey='seo.blog.title' descriptionKey='seo.blog.description' />
            <main>
                <section className="blog-hero">
                    <Container>
                        <h1>{t('blog.title')}</h1>
                        <p className="blog-subtitle">{t('blog.subtitle')}</p>
                    </Container>
                </section>
                <section className="blog-list">
                    <Container>
                        <Row>
                            {posts.map((post) => {
                                const content = post[lang];
                                return (
                                    <Col lg={4} md={6} className="mb-4" key={post.slug}>
                                        <Card className="blog-card h-100">
                                            <Link to={`/blog/${post.slug}`} className="blog-card-image-link">
                                                <Card.Img variant="top" src={post.image} alt={content.title} className="blog-card-image" />
                                            </Link>
                                            <Card.Body className="d-flex flex-column">
                                                <div className="blog-card-meta">
                                                    <span>{formatDate(post.date, lang)}</span>
                                                    <span> · {post.readingMinutes} {t('blog.minRead')}</span>
                                                </div>
                                                <Card.Title as="h2" className="blog-card-title">
                                                    <Link to={`/blog/${post.slug}`}>{content.title}</Link>
                                                </Card.Title>
                                                <Card.Text className="blog-card-description">{content.description}</Card.Text>
                                                <Link to={`/blog/${post.slug}`} className="blog-read-more mt-auto">
                                                    {t('blog.readMore')} <i className="fas fa-arrow-right"></i>
                                                </Link>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                );
                            })}
                        </Row>
                    </Container>
                </section>
            </main>
        </div>
    );
}

export default BlogPage;
